<div class="table-container">
  <table>
    <thead>
      <tr>
        <th *ngFor="let field of listaFields">{{ field.label }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of resumo.rows; let rowIndex = index">
        <td *ngFor="let cell of row">{{ getValue(cell) }}</td>
      </tr>
    </tbody>
  </table>
</div>